import { render, staticRenderFns } from "./StudentExaminationRoom.vue?vue&type=template&id=e9af8c1a&"
import script from "./StudentExaminationRoom.vue?vue&type=script&lang=js&"
export * from "./StudentExaminationRoom.vue?vue&type=script&lang=js&"
import style0 from "./StudentExaminationRoom.vue?vue&type=style&index=0&id=e9af8c1a&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports